import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/fastShippingCopySignedOut/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showFastShippingCopySignedOutSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showFastShippingCopySignedOutSelector };
